module.exports = __webpack_public_path__ + "static/media/focus.8f8fbdfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程星智/focus.png
// module id = 688
// module chunks = 0